/**
 * Récompense du bilan de fin d'exercice : l'avatar de l'élève dans son aura
 * électrique (`AvatarAura`), dont la PUISSANCE monte de 0 jusqu'au % de
 * réussite de l'exercice, dans la teinte de la SKILLCARD principale (sinon le
 * bleu de la marque). Rien si le profil n'est pas encore chargé.
 */
import { AvatarCircle } from '@jeraisonne/ui';
import { cardPalette } from '@jeraisonne/db/cards';
import { useAuth } from '@/lib/auth';
import type { ExerciseCardLink } from '@/lib/cards/student-skillcards';
import { AvatarAura } from './avatar-aura/avatar-aura';
import { useCountUp } from './use-count-up';

/** Bleu de la marque quand l'exercice n'est relié à aucune SKILLCARD. */
export const RESULT_AURA_DEFAULT_COLOR = '#0566f2';

/** Teinte de l'aura : celle de la carte principale, sinon le bleu de la marque. */
export function resultAuraColor(
  card: Pick<ExerciseCardLink, 'levels' | 'color_theme'> | null,
): string {
  return card ? cardPalette(card.levels, card.color_theme).accent : RESULT_AURA_DEFAULT_COLOR;
}

export function ResultAura({
  score,
  card,
  delay = 260,
}: {
  /** % de réussite de l'exercice (0..100). */
  score: number;
  card: Pick<ExerciseCardLink, 'levels' | 'color_theme'> | null;
  delay?: number;
}) {
  const { profile } = useAuth();
  const power = useCountUp(score, { duration: 1800, delay });
  if (!profile) return null;
  return (
    <div className="shrink-0" data-testid="result-aura">
      <AvatarAura power={power} color={resultAuraColor(card)} className="h-32 w-32 sm:h-36 sm:w-36">
        <AvatarCircle
          name={profile.display_name}
          src={profile.avatar_url}
          size="lg"
          className="shadow-lg"
        />
      </AvatarAura>
    </div>
  );
}
